import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGTMDeveloperReportView = () => {
    const eventData = {
        event: "developer_report",
        event_action: "view"
    };

    hitGoogleTagManager(eventData);
};

export const hitGTMDeveloperReportClick = () => {
    const eventData = {
        event: "developer_report",
        event_action: "click"
    };

    hitGoogleTagManager(eventData);
};

export const hitGTMDeveloperReportDownload = () => {
    const eventData = {
        event: "developer_report",
        event_action: "download"
    };

    hitGoogleTagManager(eventData);
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGTMDeveloperReportView = () => {
    const eventData = {
        event: "developer_report",
        event_action: "view"
    };

    hitGoogleTagManager(eventData);
};

export const hitGTMDeveloperReportClick = () => {
    const eventData = {
        event: "developer_report",
        event_action: "click"
    };

    hitGoogleTagManager(eventData);
};

export const hitGTMDeveloperReportDownload = () => {
    const eventData = {
        event: "developer_report",
        event_action: "download"
    };

    hitGoogleTagManager(eventData);
};
